const GENESYS_API_URL = process.env.GENESYS_API_URL;
const GENESYS_KEY = process.env.GENESYS_KEY;
const GENESYS_ORGUID = process.env.GENESYS_ORGUID;

export default function getGenesysConfig(){
  const config = {
    "widgets": {
      main: {
        themes: {
          "medicard": "cx-theme-medicard"
        },
        theme: "medicard",
        lang: "en",
        i18n: {
          "en": {
            "webchat": {
              "ChatTitle": "Live Chat",
              "ChatStarted": "Please wait, we will connect you to our agent...",
              "ChatEnded": "Chat Ended",
              "AgentConnected": "<%Agent%> Connected",
              "AgentDisconnected": "<%Agent%> Disconnected",
            },
          }
        }
      },
      "webchat": {
        "transport": {
          "type": "purecloud-v2-sockets",
          "dataURL": 'https://api.mypurecloud.jp',
          "deploymentKey": '7f9104b6-14ab-4700-b50e-9edf61ce00f5',
          "orgGuid": '548efce7-93ae-4524-84be-7b1e6b8b0681',
          "interactionData": {
            "routing": {
              "targetType": "QUEUE",
              "targetAddress": "",
              "priority": 5,
              "agentEmail":"",
              "skills":[]
            }
          }
        },
        "userData": {
        },
      }
    }
  };
  return config;
}